import { Selector } from '@ngxs/store';
import { AuthState, AuthStateModel } from '@shared/store/auth/auth.state';
import { TokenDTO } from '@data/auth/TokenDTO';
import { PsychologistDTO } from '@data/common/PsychologistDTO';

export class AuthSelectors {
  @Selector([ AuthState ])
  static getCurrentLogged(state: AuthStateModel) {
    return state.loggedUser;
  }

  @Selector([ AuthState ])
  static isLogging(state: AuthStateModel) {
    return state.isLogging;
  }

  @Selector([ AuthState ])
  static username(state: AuthStateModel) {
    return state.username;
  }

  @Selector([ AuthState ])
  static hasConfirmedReferral(state: AuthStateModel) {
    return state.loggedUser.hasConfirmedReferral;
  }


  @Selector([ AuthState ])
  static token(state: AuthStateModel): TokenDTO {
    return state.token;
  }

  @Selector([ AuthState ])
  static isAuthenticated(state: AuthStateModel): boolean {
    return !!state.token;
  }

  @Selector([ AuthState ])
  static hasAssignedPsychologist(state: AuthStateModel) {
    return !!state.loggedUser.assignedCoPsychologist || !!state.loggedUser.assignedPsychologist;
  }

  @Selector([ AuthState ])
  static getAssignedPsychologists(state: AuthStateModel) {
    if (!state.loggedUser) {
      return [];
    }

    const psychologists: PsychologistDTO[] = [];

    if (state.loggedUser.assignedPsychologist) {
      psychologists.push(state.loggedUser.assignedPsychologist);
    }

    if (state.loggedUser.assignedCoPsychologist) {
      psychologists.push(state.loggedUser.assignedCoPsychologist);
    }

    return psychologists;
  }
}